import { Component, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ApplicantService } from '../../applicant.service';
import { CibilReportService } from './cibil-report.service';
// import { QuestionsComponent } from '../questions/questions.component';


@Component({
  selector: 'wl-crif-report',
  templateUrl: './cibil-report.component.html',
  styles: [`
      .active {
        background-color: #116e90;
        color: #fff;
        }
      a:hover {
        background:#87bbce
        }
        .myclass {
          border-color:#dee2e6 #dee2e6 #fff;
          color:#fff !important;
          background-color:#506c84;
          border-bottom : 2px Solid #3f51b5 !important;
          opacity:0.6 !important;
          background-clip: padding-box;
        }
        .tabClass{
          text-align: center; 
          max-width: 25%; 
          flex-basis: 100%;
        }
        .tabContent{
          padding : 15px !important;
        }
    `],
  providers : [CibilReportService]
})
export class CrifReportComponent implements OnInit {

  tab1: boolean = true;
  tab2: boolean = false;
  imageBase64: string;
  
  constructor(private cibil : CibilReportService) { }

  ngOnInit() {

  }

  downloadPdf() {
    const linkSource = 'data:application/pdf;base64,' + this.imageBase64;
    const downloadLink = document.createElement("a");
    const fileName = "CibilReport.pdf";

    downloadLink.href = linkSource;
    downloadLink.target = '_blank'
    downloadLink.download = fileName;

    downloadLink.click();
  }

  addClass(i) {
    switch (i) {
      case 1:
        this.tab1 = true;
        this.tab2 = false;
        break;

      case 2:
        this.tab1 = false;
        this.tab2 = true;
        break; 

      default:
        this.tab1 = true;
        this.tab2 = false;
        break;
    }
  }
}
